import { render, staticRenderFns } from "./FichaTecnicaBotoesFlutuantes.vue?vue&type=template&id=7d05c1f9&scoped=true"
import script from "./FichaTecnicaBotoesFlutuantes.vue?vue&type=script&lang=js"
export * from "./FichaTecnicaBotoesFlutuantes.vue?vue&type=script&lang=js"
import style0 from "./FichaTecnicaBotoesFlutuantes.vue?vue&type=style&index=0&id=7d05c1f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d05c1f9",
  null
  
)

export default component.exports